import moment from 'moment'
import * as React from 'react'
import styled from 'styled-components'
import { getTimeRemaining } from '../../utils/time'
import useInterval from '../../utils/useInterval'

interface TimeProps {
  scheduledTime: Date
  setIsLive?: (live: boolean) => void
  small?: boolean
  isLive?: boolean
}

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
`

const TimeDiv = styled.div`
  display: flex;
  flex-direction: row;
`

const TimeComponentDiv = styled.div<{ last?: boolean; first?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${(props) => (props.last ? '0' : '10px')};
`

const Content = styled.div`
  color: white;
  font-weight: 500;
  // mobile
  font-size: 18px;
  // tablet
  @media (min-width: 43em) {
    font-size: 24px;
  }
  // small desktop+
  @media (min-width: 62em) {
    font-size: 30px;
  }
  // large desktop
  @media (min-width: 82em) {
    font-size: 34px;
  }
`

const PreviewTime = ({ scheduledTime, isLive, setIsLive }: TimeProps): JSX.Element => {
  const [time, setTime] = React.useState(getTimeRemaining(scheduledTime))

  useInterval(() => {
    const time = getTimeRemaining(scheduledTime)
    if (time.days <= 0 && time.hours <= 0 && time.minutes <= 0 && time.seconds <= 0) {
      console.log('reloading after expiry')
      if (setIsLive && !isLive) {
        setIsLive(true)
      }
    } else {
      setTime(time)
      if (setIsLive && isLive) {
        setIsLive(false)
      }
    }
  }, 1000)

  return (
    <OuterDiv>
      {time.days > 0 ? (
        <TimeDiv>
          <TimeComponentDiv last>
            <Content>
              {moment(scheduledTime).format('ddd M/D') +
                ' @' +
                moment(scheduledTime).format('h:mmA')}
            </Content>
          </TimeComponentDiv>
        </TimeDiv>
      ) : (
        <TimeDiv>
          <TimeComponentDiv first>
            <Content>{String(time.hours) + 'h'}</Content>
          </TimeComponentDiv>
          <TimeComponentDiv>
            <Content>{String(time.minutes) + 'm'}</Content>
          </TimeComponentDiv>
          <TimeComponentDiv last>
            <Content>{String(time.seconds) + 's'}</Content>
          </TimeComponentDiv>
        </TimeDiv>
      )}
    </OuterDiv>
  )
}

export default PreviewTime
